import { useState, type ReactNode } from "react";
import type { EquipmentKey } from "@frontier/content/arsenal";
import type { HullId, Profile } from "@frontier/protocol/contracts";
import type { ArsenalIntent } from "./arsenal-operations";
import { ArsenalPending } from "./ArsenalPending";
import { HullPicker } from "./HullPicker";
import { HullShowcase } from "./HullShowcase";
import { HullAcquisition } from "./HullAcquisition";
import { EquipmentMarket } from "./EquipmentMarket";
import type { EquipmentFocus } from "./equipment-focus";
import "./station-market.css";

export function StationMarket({ profile, busy, supplies, onPurchaseHull, onInstallHull, onBuyEquipment, onHangar, pendingArsenal, onRetryArsenal, initialCategory = "ships" }: {
  profile: Profile;
  busy: boolean;
  supplies?: ReactNode;
  onPurchaseHull: (id: HullId) => Promise<void>;
  onInstallHull: (id: HullId) => Promise<void>;
  onBuyEquipment: (key: EquipmentKey) => Promise<Profile | void>;
  onHangar: (focus?: EquipmentFocus, hullId?: HullId) => void;
  pendingArsenal: readonly ArsenalIntent[];
  onRetryArsenal: (intent: ArsenalIntent) => Promise<void>;
  initialCategory?: "ships" | "equipment";
}) {
  const [category, setCategory] = useState<"ships" | "equipment" | "supplies">(initialCategory);
  const [hull, setHull] = useState(profile.hullId);
  return (
    <section className="station-market" aria-label="Магазин станции">
      <nav className="station-activity-tabs" aria-label="Товары станции">
        <button aria-pressed={category === "ships"} onClick={() => setCategory("ships")}>КОРАБЛИ</button>
        <button aria-pressed={category === "equipment"} onClick={() => setCategory("equipment")}>МОДУЛИ И ОРУДИЯ</button>
        <button aria-pressed={category === "supplies"} onClick={() => setCategory("supplies")}>РАСХОДНИКИ</button>
      </nav>
      <ArsenalPending pending={pendingArsenal} busy={busy} onRetry={onRetryArsenal} />
      {category === "ships" ? <><div className="market-ships">
        <HullPicker selected={profile.hullId} previewed={hull} owned={profile.ownedHulls} purchasingAllowed busy={busy} onPreview={setHull} />
        <div className="market-ship-detail">
          <HullShowcase market hullId={hull} installed={profile.hullId} owned={profile.ownedHulls} balance={profile.credits} components={profile.components} purchasingAllowed busy={busy} onInstall={onInstallHull} onPurchase={onPurchaseHull} />
        </div>
      </div><HullAcquisition market hullId={hull} installed={profile.hullId} owned={profile.ownedHulls} balance={profile.credits} components={profile.components} purchasingAllowed busy={busy} onInstall={onInstallHull} onPurchase={onPurchaseHull} onHangar={() => onHangar(undefined, hull)} /></> : category === "equipment" ? <EquipmentMarket profile={profile} busy={busy} onBuy={onBuyEquipment} onHangar={onHangar} /> : supplies}
    </section>
  );
}
